export function register() {
  // Only register in production and when not in StackBlitz
  if (
    process.env.NODE_ENV === 'production' && 
    'serviceWorker' in navigator &&
    !window.location.hostname.includes('stackblitz') &&
    !window.location.hostname.includes('localhost')
  ) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('ServiceWorker registration successful');
        })
        .catch((error) => {
          console.error('ServiceWorker registration failed:', error);
        });
    });
  }
}